export default __webpack_public_path__ + "static/media/28_MIRDC.c82cf4b1.png";